import PropTypes from 'prop-types';
import React from 'react';
import BlogPostTile from './post-tile';
import Pagination from './pagination';

function BlogPostContainer({ posts, currentPage, numPages, paginationLink }) {
	return (
		<div className="flex-grow bg-grey-100 py-8 border-t lg:border-0 border-grey-330">
			<div>{posts && posts.map(post => <BlogPostTile key={post.id} post={post} />)}</div>
			<div className="flex justify-center items-center">
				<Pagination numPages={numPages} currentPage={currentPage} paginationLink={paginationLink} />
			</div>
		</div>
	);
}

BlogPostContainer.propTypes = {
	posts: PropTypes.array.isRequired,
};

export default BlogPostContainer;
